import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import GerenciarDiasAtrasos from './GerenciarDiasAtrasos';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function Analistas() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const [showDiasAtrasosModal, setShowDiasAtrasosModal] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-ct"
            requests={{
              findAll: () => api.get('/signed/empresa/gestorprojeto/gerencia/analistas'),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/gerencia/analista', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/gerencia/analista', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: 'Analistas',
              subTitle: 'Adicione os seus Analistas',
              icone: 'submenu-analistas',
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 1,
              list: [
                {
                  corDestaque: localStorage.getItem('tema') == 'E' ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Ativo',
                  value: { ativo: true },
                },
              ],
            }}
            inputs={[
              { filter: 'nome', label: 'Nome' },
              { filter: 'id', label: 'Id' },
            ]}
            beforeButtonCreate
            onClickBeforeButtonCreate={() => {
              setShowDiasAtrasosModal(true);
            }}
          >
            <SLEditModal
              title={
                showDiasAtrasosModal ? 'Gerenciar Dias de atrasos analistas' : 'Atualizar Analista'
              }
              menu={true}
              onClose={() => {
                setShowDiasAtrasosModal(false);
              }}
              setter={data => {
                setMountedData(data);
              }}
            >
              {showDiasAtrasosModal ? (
                <GerenciarDiasAtrasos
                  onClose={() => setShowDiasAtrasosModal(false)}
                  analistasOriginais={data}
                />
              ) : (
                mountedData && modulos && <CreateEditContent {...{ modulos, mountedData }} />
              )}
            </SLEditModal>

            <SLCreateModal title="Adicionar Analista">
              {modulos && <CreateEditContent {...{ modulos }} />}
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
